import styled from 'styled-components'
import { Row } from 'react-grid-system'

export const StyledPersonalCareContainer = styled(Row)`
  img {
    width: 100%;
  }
`
